































































import { Component, Vue } from 'vue-property-decorator';
import newButton from '@/components/Reusable/NewButton.vue';
import { Action, Getter, Mutation } from 'vuex-class';
import userStaffType from '@/store/types/userStaff';
import { UserStaffParams } from '@/store/interfaces/staffUser';
import resetPasswordConfirmation from '@/components/modals/actionConfirm.vue';
import { TeipNotifications } from '@/util/teipNotifications';
import passwordType from '@/store/types/password';
import { VuexFunction } from '@/ts/axios';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { responseDataPagination } from '@/store/interfaces/json-api/generics';

@Component({
  name: 'UserStaffList',
  components: {
    newButton,
    resetPasswordConfirmation,
  },
})
class UserStaff extends Vue {
  propsToSearch: tPropsToSearch = [];
  showModal = false;
  tableColumns: tTableColumns = [
    {
      prop: 'name',
      label: 'Nombre',
      minWidth: 250,
      sortable: true,
      formatter: (params: UserStaffParams): string => {
        return `${params.profile.first_name} ${params.profile.last_name}`;
      },
    },
    {
      prop: 'email',
      label: 'Correo',
      minWidth: 275,
      sortable: true,
    }
  ];

  userSelected: UserStaffParams = {
    email: '',
    id: '',
    permission_groups: [
      { id: '', name: '', kind: 'staff', }
    ],
    profile: {
      first_name: '',
      id: '',
      last_name: '',
    },
  };

  account = '';
  accounts_filter = [
    {
      id: '1',
      value: 'Cuentas',
    },
    {
      id: '2',
      value: 'Activos',
    },
    {
      id: '3',
      value: 'Bloqueados',
    }
  ];

  rowSelect(user: UserStaffParams): void {
    this.userSelected = user;
  }

  seeProfile(): void {
    this.setUserStaff(this.userSelected);
    this.$router.push({
      path: `staff/${this.userSelected.id}`,
    });
  }

  restartPassword(): void {
    this.showModal = true;
  }

  confirmResetPassword(): void {
    const notification = new TeipNotifications();
    this.resetPass({ user_id: this.userSelected.id, })
      .then(() => {
        this.showModal = false;
        notification.success(
          'Contraseña restablecida',
          'Se ha enviado un email de restablecimiento'
        );
      })
      .catch(() => {
        notification.warning(
          '¡Error!',
          'No hemos podido restablecer contraseña :('
        );
      });
  }

  @Action(`userStaff/${userStaffType.actions.USER_STAFF}`)
  listUserStaff!: VuexFunction;

  @Action(`passwordModule/${passwordType.actions.RESET_PASSWORD}`)
  resetPass!: VuexFunction;

  @Getter(`userStaff/${userStaffType.getters.GET_USER_STAFF}`)
  getlistUserStaff!: responseDataPagination<UserStaffParams>;

  @Mutation(`userStaff/${userStaffType.mutations.SET_SINGLE_USER_STAFF}`)
  setUserStaff!: VuexFunction;
}
export default UserStaff;
